// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__25Ffh","large":"styles_large__3n3Tq"};